import "./styles.css";

import { applyMotion } from "./motion";
import { MuseumShell } from "./shell";

// Before the shell renders, so no scene is ever built against the wrong answer.
applyMotion();

const root = document.querySelector<HTMLElement>("#app");
if (root === null) throw new Error("UI_ELEMENT_MISSING: #app");

const shell = new MuseumShell(root);
void shell.start();
